import hero from './hero';

const productPrices = document.querySelectorAll('.price');
const productOverviewLabel = document.querySelectorAll(
	'.product-overview-radio-label',
);
const productListGrid = document.querySelector('.product-list-grid');
const isGridFiltered = productListGrid?.getAttribute('data-is-filterd');

let initialFilter = productListGrid?.getAttribute('data-curr-filter');
if (isGridFiltered && initialFilter !== 'katze' && initialFilter !== 'hund')
	initialFilter = 'hund';
productOverviewLabel.forEach((label) => {
	const field = label.querySelector('input');
	const cards = productListGrid?.querySelectorAll(`[data-card-type]`);
	cards.forEach((currCard) => {
		const toggleCard =
			currCard.getAttribute('data-card-type') === initialFilter;
		if (isGridFiltered) currCard.classList.toggle('hidden', !toggleCard);
	});
	hero.checkRadioCheckState(label, false);
	field?.addEventListener('click', (ev) => {
		handleChangeCheckState();
	});
	label.addEventListener('keydown', (ev) => {
		if (ev.key === 'Enter' || ev.key === ' ') {
			ev.preventDefault();
			field.checked = true;
			handleChangeCheckState();
		}
	});

	function handleChangeCheckState() {
		cards.forEach((currCard) => {
			const toggleCard =
				currCard.getAttribute('data-card-type') === field.value;
			if (isGridFiltered) currCard.classList.toggle('hidden', !toggleCard);
		});
		productListGrid?.setAttribute('data-curr-filter', field.value);
		productOverviewLabel.forEach((label) =>
			hero.checkRadioCheckState(label, false),
		);
	}
});

//used to show tarif dropdown for the products
const productItems = document.querySelectorAll('.product-item');

const productItemsSelect = document.querySelectorAll('.tarif-select');

const siteName = document.querySelector('[data-site-name]');

if (productItems && productItemsSelect && siteName === 'cleo-jagd') {
	productItems.forEach((item) => {
		const productPriceElement = item.querySelector('.product-price');
		const calculateProductLink = item.querySelector('.calculate-product-link');

		// Get the tarif options from the data attribute
		const tarifOptions = JSON.parse(item.dataset.tarifOptions);

		// Loop through each li element
		const listItems = item.querySelectorAll('.select-input-option'); // Assuming <li> elements have this class

		listItems.forEach((listItem) => {
			listItem.addEventListener('click', function () {
				const selectedValue = this.dataset.value;

				// Find the matching tarif option
				const selectedTarif = tarifOptions.find(
					(option) => option.value === selectedValue,
				);

				if (selectedTarif) {
					// Update the price element
					if (productPriceElement) {
						productPriceElement.textContent = selectedTarif.price;
					}

					// Update the calculate link href
					if (calculateProductLink) {
						calculateProductLink.href = selectedTarif.calculateLink;
					}
				}
			});
		});
	});
}

const changeNumbers = () => {
	productPrices.forEach((productPrice) => {
		let priceNumber = parseFloat(productPrice.textContent);
		let formattedNumber = priceNumber.toLocaleString(undefined, {
			minimumFractionDigits: 0,
		});
		productPrice.textContent = formattedNumber;
	});
};

// if (productPrices) {
// 	changeNumbers()
// }

export default {
	productPrices: productPrices,
	productOverviewLabel: productOverviewLabel,
};
